import Cover from './cover.jpeg'
import Hero from './21.jpg'
import Image1 from './1.jpg'
import Image2 from './2.jpg'
import Image3 from './3.jpg'
import Image4 from './4.jpg'
import Image5 from './5.jpg'
import Image6 from './6.jpg'
import Image7 from './7.jpg'
import Image8 from './8.jpg'
import Image9 from './9.jpg'
import Image10 from './10.jpg'
import Image11 from './11.jpg'
import Image12 from './12.jpg'
import Image13 from './13.jpg'
import Image14 from './14.jpg'
import Image15 from './15.jpg'
import Image16 from './16.jpg'
import Image17 from './17.jpg'
import Image18 from './18.jpg'
import Image19 from './19.jpg'
import Image20 from './20.jpg'
import Image21 from './21.jpg'
import Image22 from './22.jpg'
import Image23 from './23.jpg'
import Image24 from './24.jpg'
import Image25 from './25.jpg'
import Image26 from './26.jpg'
import Image27 from './27.jpg'
import Image28 from './28.jpg'
import Image29 from './29.jpg'
import Image30 from './30.jpg'
import Image31 from './31.jpg'
import Image32 from './32.jpg'
import Image33 from './33.jpg'
import Image34 from './34.jpg'
import Image35 from './35.jpg'
import Image36 from './36.jpg'
import Image37 from './37.jpg'
import Image38 from './38.jpg'
import Image39 from './39.jpg'
import Image40 from './40.jpg'
import Image41 from './41.jpg'
import Image42 from './42.jpg'
import Image43 from './43.jpg'
import Image44 from './44.jpg'
import Image45 from './45.jpg'
import Image46 from './46.jpg'
import Image47 from './47.jpg'
import Image48 from './48.jpg'
import Thumbnail1 from './1t.jpg'
import Thumbnail2 from './2t.jpg'
import Thumbnail3 from './3t.jpg'
import Thumbnail4 from './4t.jpg'
import Thumbnail5 from './5t.jpg'
import Thumbnail6 from './6t.jpg'
import Thumbnail7 from './7t.jpg'
import Thumbnail8 from './8t.jpg'
import Thumbnail9 from './9t.jpg'
import Thumbnail10 from './10t.jpg'
import Thumbnail11 from './11t.jpg'
import Thumbnail12 from './12t.jpg'
import Thumbnail13 from './13t.jpg'
import Thumbnail14 from './14t.jpg'
import Thumbnail15 from './15t.jpg'
import Thumbnail16 from './16t.jpg'
import Thumbnail17 from './17t.jpg'
import Thumbnail18 from './18t.jpg'
import Thumbnail19 from './19t.jpg'
import Thumbnail20 from './20t.jpg'
import Thumbnail21 from './21t.jpg'
import Thumbnail22 from './22t.jpg'
import Thumbnail23 from './23t.jpg'
import Thumbnail24 from './24t.jpg'
import Thumbnail25 from './25t.jpg'
import Thumbnail26 from './26t.jpg'
import Thumbnail27 from './27t.jpg'
import Thumbnail28 from './28t.jpg'
import Thumbnail29 from './29t.jpg'
import Thumbnail30 from './30t.jpg'
import Thumbnail31 from './31t.jpg'
import Thumbnail32 from './32t.jpg'
import Thumbnail33 from './33t.jpg'
import Thumbnail34 from './34t.jpg'
import Thumbnail35 from './35t.jpg'
import Thumbnail36 from './36t.jpg'
import Thumbnail37 from './37t.jpg'
import Thumbnail38 from './38t.jpg'
import Thumbnail39 from './39t.jpg'
import Thumbnail40 from './40t.jpg'
import Thumbnail41 from './41t.jpg'
import Thumbnail42 from './42t.jpg'
import Thumbnail43 from './43t.jpg'
import Thumbnail44 from './44t.jpg'
import Thumbnail45 from './45t.jpg'
import Thumbnail46 from './46t.jpg'
import Thumbnail47 from './47t.jpg'
import Thumbnail48 from './48t.jpg'

export {
  Cover,
  Hero,
  Image1,
  Image2,
  Image3,
  Image4,
  Image5,
  Image6,
  Image7,
  Image8,
  Image9,
  Image10,
  Image11,
  Image12,
  Image13,
  Image14,
  Image15,
  Image16,
  Image17,
  Image18,
  Image19,
  Image20,
  Image21,
  Image22,
  Image23,
  Image24,
  Image25,
  Image26,
  Image27,
  Image28,
  Image29,
  Image30,
  Image31,
  Image32,
  Image33,
  Image34,
  Image35,
  Image36,
  Image37,
  Image38,
  Image39,
  Image40,
  Image41,
  Image42,
  Image43,
  Image44,
  Image45,
  Image46,
  Image47,
  Image48,
  Thumbnail1,
  Thumbnail2,
  Thumbnail3,
  Thumbnail4,
  Thumbnail5,
  Thumbnail6,
  Thumbnail7,
  Thumbnail8,
  Thumbnail9,
  Thumbnail10,
  Thumbnail11,
  Thumbnail12,
  Thumbnail13,
  Thumbnail14,
  Thumbnail15,
  Thumbnail16,
  Thumbnail17,
  Thumbnail18,
  Thumbnail19,
  Thumbnail20,
  Thumbnail21,
  Thumbnail22,
  Thumbnail23,
  Thumbnail24,
  Thumbnail25,
  Thumbnail26,
  Thumbnail27,
  Thumbnail28,
  Thumbnail29,
  Thumbnail30,
  Thumbnail31,
  Thumbnail32,
  Thumbnail33,
  Thumbnail34,
  Thumbnail35,
  Thumbnail36,
  Thumbnail37,
  Thumbnail38,
  Thumbnail39,
  Thumbnail40,
  Thumbnail41,
  Thumbnail42,
  Thumbnail43,
  Thumbnail44,
  Thumbnail45,
  Thumbnail46,
  Thumbnail47,
  Thumbnail48,
}
